var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Builder } from 'flatbuffers';
import { isHttpClient } from '../httpclient';
import Axios from 'axios';
/**
 *  Level constants
 */
export var Level;
(function (Level) {
    Level[Level["Trace"] = 0] = "Trace";
    Level[Level["Debug"] = 1] = "Debug";
    Level[Level["Info"] = 2] = "Info";
    Level[Level["Warn"] = 3] = "Warn";
    Level[Level["Error"] = 4] = "Error";
    Level[Level["Fatal"] = 5] = "Fatal";
    Level[Level["Panic"] = 6] = "Panic";
})(Level || (Level = {}));
export default class ExternalLoggerService {
    constructor(settings) {
        this._settings = createSettings(settings);
        this._url = `${this._settings.proto}://${this._settings.host}`;
    }
    /**
     *  Log a message to the external service.
     */
    log(level, slug, data) {
        const httpClient = this._settings.httpClient;
        const url = this._url;
        // Do not block execution flow
        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            try {
                yield httpClient.post(url, Buffer.from(buildFlatBuffer(level, slug, data)));
            }
            catch (e) {
                console.error('Failed to send log to external service', e);
            }
        }), 0);
    }
}
/**
 *  Send data to external url as flat buffer
 */
function buildFlatBuffer(level, slug, data) {
    const builder = new Builder(128);
    const messageOffset = builder.createString(slug);
    const fieldsArr = [];
    for (const [key, value] of Object.entries(data)) {
        const keyOffset = builder.createString(key);
        const valueOffset = builder.createString(value);
        builder.startObject(2);
        builder.addFieldOffset(0, keyOffset, 0);
        builder.addFieldOffset(1, valueOffset, 0);
        fieldsArr.unshift(builder.endObject());
    }
    builder.startVector(4, fieldsArr.length, 4);
    for (const offset of fieldsArr) {
        builder.addOffset(offset);
    }
    const fieldsOffset = builder.endVector();
    builder.startObject(3);
    builder.addFieldOffset(0, messageOffset, 0);
    builder.addFieldInt8(1, level, Level.Trace);
    builder.addFieldOffset(2, fieldsOffset, 0);
    builder.finish(builder.endObject());
    return builder.asUint8Array();
}
/**
 *  Create settings object merged from defaults and partial settings object.
 *
 *  @param settings The partial settings for the external logger.
 */
function createSettings(settings) {
    if (!settings.entityId) {
        throw new Error('Missing entityId in settings');
    }
    if (!settings.host) {
        throw new Error('Missing host in settings');
    }
    // Check if the provided httpClient implements the correct interface
    if (settings.httpClient && !isHttpClient(settings.httpClient)) {
        throw new Error('No valid HTTP client provided');
    }
    return Object.assign(Object.assign({ proto: 'https' }, settings), { httpClient: settings.httpClient || Axios.create() });
}
//# sourceMappingURL=external.js.map